'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  border: 1px solid ', ';\n  border-radius: 5px;\n  padding: 10px;\n  min-width: 100px;\n  cursor: pointer;\n'], ['\n  position: relative;\n  border: 1px solid ', ';\n  border-radius: 5px;\n  padding: 10px;\n  min-width: 100px;\n  cursor: pointer;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  text-align: center;\n  font-size: 1em;\n  color: ', ';\n'], ['\n  text-align: center;\n  font-size: 1em;\n  color: ', ';\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  text-align: center;\n  color: ', ';\n  font-size: 1em;\n  font-weight: 900;\n'], ['\n  text-align: center;\n  color: ', ';\n  font-size: 1em;\n  font-weight: 900;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _color = require('../../color');

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styledComponents2.default.div(_templateObject, _color2.default.purple_main);

var Title = _styledComponents2.default.div(_templateObject2, _color2.default.blue_main);

var Content = _styledComponents2.default.div(_templateObject3, _color2.default.blue_main);

var MozartStatSquare = function MozartStatSquare(props) {
  var style = props.style,
      title = props.title,
      data = props.data,
      testId = props.testId,
      themeId = props.themeId;

  return _react2.default.createElement(
    Container,
    _extends({}, props, { style: style, 'data-qa': testId, 'data-theme': themeId }),
    _react2.default.createElement(
      Title,
      null,
      title
    ),
    _react2.default.createElement(
      Content,
      null,
      data
    )
  );
};

MozartStatSquare.propTypes = {
  /** qa attribute */
  testId: _propTypes2.default.string,
  /** theme attribute */
  themeId: _propTypes2.default.string,
  /** override style */
  style: _propTypes2.default.object,
  /** title */
  title: _propTypes2.default.oneOf([_propTypes2.default.string, _propTypes2.default.node]),
  /** content */
  data: _propTypes2.default.oneOf([_propTypes2.default.string, _propTypes2.default.node])
};

MozartStatSquare.defaultProps = {
  testId: 'MozartStatSquare',
  themeId: 'MozartStatSquare'
};

exports.default = MozartStatSquare;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Mozart/MozartStatBox/MozartStatSquare/MozartStatSquare.js
// module id = 1951
// module chunks = 1